export const FatalStartupErrorScreen = (error: unknown) => {
  if (error instanceof Error) {
    return (
      <div>
        <h3>Error wiring dependencies</h3>
        <p>{error.message}</p>
      </div>
    );
  }
  return (
    <div>
      <h3>Error constructing application</h3>
      <p>Unknown error occurred during wire validation</p>
    </div>
  );
};
